export default "__VITE_ASSET__CFyh8_t0__"